<script>
import simplebar from "simplebar-vue";

import { authComputed } from "@/state/helpers";
import {mapState} from 'vuex';
let user = JSON.parse(localStorage.getItem("user"));

/**
 * Nav-bar Component
 */
export default {
  components: { simplebar },

  methods: {
    logoutUser(){
      localStorage.removeItem("user");
      this.$router.push({name:"login"})
    },

    editPassword(){
      this.$router.push({
        name:"edit-password",
        query:{
          id: user._id
        }
      })
    },
    toggleMenu() {
      this.$parent.toggleMenu();
    },
    toggleRightSidebar() {
      this.$parent.toggleRightSidebar();
    }
  },
  computed: {
    ...authComputed,
      ...mapState("authapi", ["user"])
  },
};
</script>

<template>
  <header id="page-topbar">
    <div class="navbar-header">
      <div class="d-flex">
        <!-- LOGO -->
        <div class="navbar-brand-box">
          <router-link to="/" class="logo logo-dark">
            <span class="logo-sm">
              <img src="@/assets/images/logo.svg" alt height="22" />
            </span>
            <span class="logo-lg">
              <img src="@/assets/images/logo-dark.png" alt height="17" />
            </span>
          </router-link>

          <router-link to="/" class="logo logo-light">
            <span class="logo-sm">
              <img src="@/assets/images/logo-light.svg" alt height="22" />
            </span>
            <span class="logo-lg">
              <img src="@/assets/images/logo-light.png" alt height="19" />
            </span>
          </router-link>
        </div>

        <button
          id="vertical-menu-btn"
          type="button"
          class="btn btn-sm px-3 font-size-16 header-item"
          @click="toggleMenu"
        >
          <i class="fa fa-fw fa-bars"></i>
        </button>


      </div>

      <div class="d-flex">
      

      
        <b-dropdown
          right
          variant="black"
          toggle-class="header-item"
          menu-class="dropdown-menu-end"
        >
          <template v-slot:button-content>
            <img
              class="rounded-circle header-profile-user"
              :src="user.avatar ? user.avatar : '@/assets/images/users/avatar-1.jpg'"
              :alt="user.username"
            />
            <span class="d-none d-xl-inline-block d-md-inline-block ms-1">
             
              <div v-if="user">
               {{user.username}}
              </div>
              <div v-else>
                Henry123
              </div>
              </span
            >
            <i class="mdi mdi-chevron-down d-none d-xl-inline-block"></i>
          </template>
          <!-- item-->

          <span @click="editPassword" class="dropdown-item">
            <i
              class="bx bx-user-circle font-size-16 align-middle me-1"
            ></i>
            Đổi mật khẩu
          </span>


          <span @click="logoutUser" class="dropdown-item">
            <i
              class="bx bx-power-off font-size-16 align-middle me-1"
            ></i>
            {{ "Đăng xuất" }}
          </span>
        </b-dropdown>

      </div>
    </div>
  </header>
</template>
